// extracted by mini-css-extract-plugin
export var card = "auction-card--card--2q4dr";
export var card__img = "auction-card--card__img--3Xyl6";
export var card__body = "auction-card--card__body--4wXCF";
export var card__title = "auction-card--card__title--21pth";